// extracted by mini-css-extract-plugin
export default {"todo-item":"styles_todo-item__Q8PMH","details-btn":"styles_details-btn__dt37q","todo-done":"styles_todo-done__spBJy"};